"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainSelector = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Button/Button"));
var ModalContent_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Modal/ModalContent"));
var classnames_1 = __importDefault(require("classnames"));
var schemas_1 = require("@dcl/schemas");
var Media_1 = require("../Media");
var Modal_1 = require("../Modal/Modal");
var ModalNavigation_1 = require("../ModalNavigation/ModalNavigation");
require("./ChainSelector.css");
var ChainNameIconMap = (_a = {},
    _a[schemas_1.ChainId.ETHEREUM_MAINNET] = 'ethereum',
    _a[schemas_1.ChainId.ETHEREUM_SEPOLIA] = 'ethereum',
    _a[schemas_1.ChainId.MATIC_MAINNET] = 'polygon',
    _a[schemas_1.ChainId.MATIC_MUMBAI] = 'polygon',
    _a[schemas_1.ChainId.ARBITRUM_MAINNET] = 'arbitrum',
    _a[schemas_1.ChainId.OPTIMISM_MAINNET] = 'optimism',
    _a[schemas_1.ChainId.FANTOM_MAINNET] = 'fantom',
    _a[schemas_1.ChainId.BSC_MAINNET] = 'bsc',
    _a[schemas_1.ChainId.AVALANCHE_MAINNET] = 'avalanche',
    _a);
var ChainSelector = function (props) {
    var chains = props.chains, selectedChain = props.selectedChain, chainBeingConfirmed = props.chainBeingConfirmed, i18n = props.i18n, onSelectChain = props.onSelectChain;
    var chainBeingConfirmedRef = (0, react_1.useRef)(chainBeingConfirmed);
    var isMobileOrTablet = (0, Media_1.useTabletAndBelowMediaQuery)();
    // This effect is used to close the modal when the chain being confirmed changes
    (0, react_1.useEffect)(function () {
        if (selectedChain && selectedChain === chainBeingConfirmedRef.current) {
            chainBeingConfirmedRef.current = undefined;
            setShowModal(false);
        }
    }, [selectedChain]);
    var _a = (0, react_1.useState)(false), showModal = _a[0], setShowModal = _a[1];
    var title = (i18n === null || i18n === void 0 ? void 0 : i18n.title) || 'Select Network';
    var onButtonClick = (0, react_1.useCallback)(function () {
        setShowModal(!showModal);
    }, []);
    var onSelectChainHandler = (0, react_1.useCallback)(function (chainId) {
        onSelectChain(chainId);
        chainBeingConfirmedRef.current = chainId;
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { className: "dui-chain-selector__button", onClick: onButtonClick },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-chain-icon', ChainNameIconMap[selectedChain]) }),
            !isMobileOrTablet
                ? selectedChain === schemas_1.ChainId.ETHEREUM_MAINNET
                    ? 'Ethereum'
                    : (0, schemas_1.getChainName)(selectedChain)
                : null),
        react_1.default.createElement(Modal_1.Modal, { open: showModal, className: "dui-chain-selector__modal", onClose: function () { return setShowModal(false); } },
            react_1.default.createElement(ModalNavigation_1.ModalNavigation, { title: title, onClose: function () { return setShowModal(false); } }),
            react_1.default.createElement(ModalContent_1.default, null,
                react_1.default.createElement("ul", { className: "dui-chain-selector__list" }, chains.map(function (chain) {
                    var chainName = chain === schemas_1.ChainId.ETHEREUM_MAINNET
                        ? 'Ethereum'
                        : (0, schemas_1.getChainName)(chain);
                    return (react_1.default.createElement("button", { key: chain, className: (0, classnames_1.default)('dui-chain-selector__element', {
                            'dui-chain-selector__element-selected': chain === selectedChain
                        }), onClick: function () { return onSelectChainHandler(chain); } },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-chain-icon', ChainNameIconMap[chain]) }),
                        chainName,
                        selectedChain === chain ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "selector__button-connected" }, i18n.connected),
                            react_1.default.createElement("div", { className: "selector__button-connected-circle" }))) : chainBeingConfirmed && chain === chainBeingConfirmed ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "selector__button-connected" }, i18n.confirmInWallet),
                            react_1.default.createElement("div", { className: "selector__button-confirm-circle" }))) : null));
                }))))));
};
exports.ChainSelector = ChainSelector;
